import { ObjectId } from '../../domain/shared/ObjectId';

export const GetEntityUrl = (objectId: ObjectId, changesetId?: string, editMode?: boolean): string => {
  const type = objectId.type.toLowerCase();
  return changesetId ? (!!editMode ? `/${type}/${objectId.id}/${changesetId}?editMode=true` : `/${type}/${objectId.id}/${changesetId}`) : `/${type}/${objectId.id}`;
};
